module.exports = __webpack_public_path__ + "static/img/jianshe.9b22962d.jpg";